<div class="flex flex-col items-center gap-5">
  @for (row of rows; track $index) {
    <div class="flex w-fit gap-5">
      @for (column of row.columns; track $index) {
        <div class="bg-surface-100 flex w-fit gap-2 rounded-lg p-2">
          @for (key of column.keys; track $index) {
            <lib-key [disabled]="disabled" [key]="key" (keyPress)="keyPress.emit(key)" />
          }
        </div>
      }
    </div>
  }
</div>
